import React, { useRef, useState } from 'react'
import {
  Badge,
  Box,
  colors,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import { Check, Notifications as NotificationsIcon } from '@mui/icons-material'
import useNotifications from '../hooks/api/useNotifications'
import { useNavigate } from 'react-router-dom'
import useAlert from '../hooks/useAlert'

const Notifications = () => {
  const { notifications, isLoading, markNotificationComplete } =
    useNotifications()
  const [menuOpen, setMenuOpen] = useState(false)

  const menuRef = useRef()
  const navigate = useNavigate()

  const handleNotificationClick = (n) => {
    setMenuOpen(false)
    if (n.uri) {
      navigate(n.uri)
    }
    if (n.leadImportCustomer) {
      setMenuOpen(false)

      const url = `/customers/${n.leadImportCustomer.id}`

      return navigate(url)
    }
  }

  const handleMarkComplete = (e, n) => {
    e.stopPropagation()
    markNotificationComplete(n)
      .then(() => {})
      .catch(createGenericErrorAlert)
  }

  const { createGenericErrorAlert } = useAlert()

  const activeNotificationsCount = notifications.filter(
    (n) => n.statusTypeId === 1
  ).length

  return (
    <Box sx={{ mr: 2 }}>
      {!isLoading && (
        <IconButton onClick={() => setMenuOpen(true)}>
          <Badge
            ref={menuRef}
            badgeContent={activeNotificationsCount}
            color={'primary'}
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
      )}

      <Menu
        sx={{ maxHeight: '400px' }}
        anchorEl={menuRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {notifications.length === 0 && (
          <MenuItem disabled sx={{ mx: 3 }}>
            <i>No notifications</i>
          </MenuItem>
        )}
        {notifications.map((n, i) => {
          const isCompleted = !!n.completedByIdentity

          return (
            <MenuItem
              key={i}
              sx={{
                color: isCompleted ? colors.grey['600'] : null,
                justifyContent: 'space-between',
              }}
              onClick={() => handleNotificationClick(n)}
            >
              <Box>
                {n.label && (
                  <Box sx={{ mr: 1 }}>
                    <Typography>
                      <b>{n.label}</b>
                    </Typography>
                  </Box>
                )}

                <Box>
                  {n.text && <Typography>{n.text}</Typography>}

                  {n.leadImportCustomer && (
                    <Typography>
                      Account name: {n?.leadImportCustomer?.name}
                    </Typography>
                  )}
                </Box>

                {isCompleted && n?.leadImportCustomer?.name && (
                  <Box>
                    <Typography>
                      <i>Completed by: {n.completedByIdentity.name}</i>
                    </Typography>
                  </Box>
                )}
              </Box>
              <IconButton
                onClick={(e) => handleMarkComplete(e, n)}
                disabled={isCompleted}
                sx={{
                  ml: 2,
                  border: isCompleted
                    ? null
                    : `1px solid ${colors.grey['300']}`,
                  color: isCompleted
                    ? `${colors.green['600']} !important`
                    : null,
                }}
              >
                <Check color={isCompleted ? '' : 'primary'} />
              </IconButton>
            </MenuItem>
          )
        })}
      </Menu>
    </Box>
  )
}

export default Notifications
